import * as tslib_1 from "tslib";
import { AbstractSearchCriteria } from './abstract-search-criteria';
var CitySearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(CitySearchCriteria, _super);
    function CitySearchCriteria() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.codeOrName = '';
        _this.code = '';
        _this.name = '';
        _this.countryCode = '';
        _this.stateCode = '';
        return _this;
    }
    return CitySearchCriteria;
}(AbstractSearchCriteria));
export { CitySearchCriteria };
